/**
 * Handles collapsible option lists in Solr facet filters.
 * Toggles visibility of additional facet items and updates toggle labels accordingly.
 */
export class CollapsibleOptionsList {
  static get TOGGLE_SELECTOR() {
    return '.tx-solr-facet-show-all';
  }

  static get HIDDEN_FACETS_SELECTOR() {
    return '.tx-solr-facet-hidden';
  }

  /**
   * @param {HTMLElement} listEl - The container element for the facet list.
   */
  constructor(listEl) {
    /** @type {HTMLElement} The root element of the facet list */
    this.listEl = listEl;

    /** @type {boolean} Whether the hidden facets are currently visible */
    this._isOpen = false;

    /** @type {NodeListOf<HTMLElement>} All toggle buttons */
    this._toggles = this.listEl.querySelectorAll(CollapsibleOptionsList.TOGGLE_SELECTOR);

    /** @type {NodeListOf<HTMLElement>} All hidden facet elements */
    this._hiddenFacets = this.listEl.querySelectorAll(CollapsibleOptionsList.HIDDEN_FACETS_SELECTOR);

    if (!this._toggles.length || !this._hiddenFacets.length) return;

    this._toggles.forEach((toggle) => {
      /** @type {string} */
      toggle.labelMore = toggle.getAttribute('data-label-more');

      /** @type {string} */
      toggle.labelLess = toggle.getAttribute('data-label-less');

      toggle.addEventListener('click', this._onToggleClick.bind(this));
    });
  }

  /**
   * @param {MouseEvent} e - The click event
   */
  _onToggleClick(e) {
    e.preventDefault();

    this._isOpen = !this._isOpen;
    this._updateListUI();
    this._updateTogglesUI();
  }

  _updateListUI() {
    this._hiddenFacets.forEach((facet) => {
      facet.style.display = this._isOpen ? 'block' : 'none';
    });
  }

  _updateTogglesUI() {
    this._toggles.forEach((toggle) => {
      if (!toggle.labelMore.length || !toggle.labelLess.length) return;

      toggle.textContent = String(this._isOpen ? toggle.labelLess : toggle.labelMore);
    });
  }
}
